import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { retrieveConventionTransferList } from "./retrieve-convention-transfer-list";
import type { ConventionPaymentVM } from "@shared-kernel/application/ports/admin/admin-repository";

const initialState: RetrievalState<ConventionPaymentVM[]> = { fetching: "idle", data: [] };

export const retrieveConventionTransferListReducer = createReducer<RetrievalState<ConventionPaymentVM[]>>(initialState, builder => {
  builder.addCase(retrieveConventionTransferList.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveConventionTransferList.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveConventionTransferList.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
